import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
// @ts-ignore
import DownloadBrochureForm from "@/components/download-brochure-form";


export default /*#__PURE__*/_defineComponent({
  props: {
    tags: { type: null, required: true },
    mailchimpIds: { type: Array, required: true, default: () => [] },
    mailchimpGroupId: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    url: { type: String, required: true },
    attrTitle: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();



const open = ref(false);

const __returned__ = { open, DownloadBrochureForm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})